export const keywordGap = {
  title: 'Keyword Gap',
  status: {
    pending: 'Pendiente',
    running: 'En curso',
    completed: 'Completado',
    failed: 'Fallido',
  },
  actions: {
    ok: {
      badge: 'OK',
      title: 'Mantener',
      description: 'Rankeás bien con la URL correcta. Vigilar y conservar.',
    },
    optimize: {
      badge: 'Optimizar',
      title: 'Mejorar posición',
      description: 'La URL es la correcta pero hay margen para subir en el ranking.',
    },
    rematch: {
      badge: 'Cambiar match',
      title: 'Re-orientar señales',
      description: 'Rankeás con una URL que no es la mejor para esa intención.',
    },
    create: {
      badge: 'Crear',
      title: 'Crear contenido',
      description: 'No tenés contenido sobre estos temas. Oportunidades para captar tráfico nuevo.',
    },
    skip: {
      badge: 'No atacar',
      title: 'Fuera de scope',
      description: 'Keywords que no aplican a tu producto.',
    },
  },
  strength: {
    hard: 'Difícil',
    medium: 'Media',
    quick: 'Rápida',
  },
  rationale: {
    'ok.withPosition': 'Rankeás en pos {{position}} con la URL correcta.',
    'ok.withoutPosition': 'Rankeás con la URL correcta.',
    'optimize.withPosition':
      'Rankeás en pos {{position}} con la URL correcta. Hay margen al top {{targetPosition}}.',
    'optimize.withoutPosition': 'Tu URL es la correcta. Hay margen para mejorar posición.',
    'rematch.withBothUrls':
      'Rankeás con {{currentUrl}}, pero el intent matchea mejor con {{suggestedUrl}}.',
    'rematch.withSuggestedOnly':
      'Tu URL {{suggestedUrl}} es la correcta para esta intención pero no es la que rankea.',
    'rematch.generic': 'La URL que rankea no encaja con la intención de búsqueda.',
    'create.withCompetitorPosition':
      'No tenés contenido sobre este tema. Tu mejor competidor rankea en pos {{position}}.',
    'create.withoutCompetitorPosition':
      'No tenés contenido sobre este tema y representa una oportunidad sin cubrir.',
    'skip.outOfScope': 'Fuera del scope del producto.',
  },
  summary: {
    opportunitiesLabel: 'oportunidades accionables',
    volumeLabel: 'búsquedas/mes',
    fromAnalyzed: 'de {{total}} keywords analizadas',
    concentration: 'Concentrado en {{action}} ({{pct}}%).',
    noOpportunities: 'No se encontraron oportunidades accionables en este análisis.',
  },
  list: {
    title: 'Análisis de keyword gap',
    subtitle: 'Identificá oportunidades comparando tu sitio con tus competidores.',
    loading: 'Cargando análisis…',
    error: 'No se pudieron cargar los análisis.',
    empty: 'Todavía no hay análisis. Lanzá el primero para empezar.',
    emptyTitle: 'Sin análisis todavía',
    emptyFiltered: 'No hay análisis que coincidan con los filtros aplicados.',
    emptyFilteredTitle: 'Sin resultados',
    resultCount_one: '{{count}} análisis',
    resultCount_other: '{{count}} análisis',
    newAction: 'Nuevo análisis',
    vsClient: 'vs {{client}}',
    noCompetitors: 'Sin competidores',
    inProgressHint: 'El análisis sigue en curso',
    strategyShort: {
      by_volume: 'Volumen',
      by_traffic_potential: 'Tráfico',
      striking_distance: 'Striking',
    },
    cols: {
      client: 'Sitio',
      target: 'Competidores',
      market: 'Mercado',
      strategy: 'Estrategia',
      preset: 'Enfoque',
      status: 'Estado',
      date: 'Fecha',
    },
    deleteDialog: {
      action: 'Eliminar análisis',
      title: 'Eliminar análisis',
      description:
        'Esta acción no se puede deshacer. El análisis y todos sus resultados serán eliminados permanentemente.',
      cancel: 'Cancelar',
      confirm: 'Eliminar',
      deleting: 'Eliminando...',
      success: 'Análisis eliminado.',
      error: 'No se pudo eliminar el análisis.',
    },
  },
  history: {
    filters: {
      clientLabel: 'Sitio',
      clientPlaceholder: 'Buscar por sitio',
      competitorLabel: 'Competidor',
      competitorPlaceholder: 'Buscar por competidor',
      marketLabel: 'Mercado',
      marketPlaceholder: 'Mercado',
      allMarkets: 'Todos los mercados',
      fromLabel: 'Desde',
      toLabel: 'Hasta',
      clear: 'Limpiar filtros',
      dateRange: {
        placeholder: 'Fecha',
        apply: 'Aplicar',
        cancel: 'Cancelar',
        clear: 'Limpiar',
        presets: {
          last7Days: 'Últimos 7 días',
          last30Days: 'Últimos 30 días',
          last90Days: 'Últimos 90 días',
          monthToDate: 'Este mes',
          yearToDate: 'Este año',
        },
      },
    },
    pagination: {
      indicator: 'Página {{page}} de {{total}}',
      previous: 'Anterior',
      next: 'Siguiente',
    },
  },
  new: {
    title: 'Nuevo análisis',
    subtitle:
      'Compará tu dominio con competidores y descubrí keywords donde ellos rankean y vos no.',
  },
  detail: {
    backToList: 'Volver al listado',
    versus: 'vs {{competitors}}',
    time: {
      justNow: 'recién',
      minutesAgo: 'hace {minutes}m',
      hoursAgo: 'hace {hours}h',
      daysAgo: 'hace {days}d',
    },
    error: 'No se pudo cargar el análisis.',
    searchVolume: 'Volumen de búsqueda',
    clientPosition: 'Tu posición',
    clusterKeywordCount_one: '{{count}} keyword',
    clusterKeywordCount_other: '{{count}} keywords',
    running: {
      title: 'Tu análisis está en curso',
      subtitle:
        'Esto puede tomar unos minutos. La página se actualiza sola cuando el análisis termina.',
    },
    failed: {
      title: 'El análisis falló',
    },
    noLabsData: {
      title: 'Sin datos de Keyword Gap para {{country}}',
      description:
        'DataForSEO no tiene datos de Keyword Gap para {{country}}. Corré el análisis en otro mercado para ver resultados.',
    },
    tabs: {
      actions: 'Acciones',
      map: 'Mapa competitivo',
      table: 'Tabla',
    },
    secondaryActions: {
      title: 'Otras categorías',
      subtitle: 'Dónde más está tu dominio en este mercado.',
    },
    actionCard: {
      keywordCount_one: '{{count}} keyword',
      keywordCount_other: '{{count}} keywords',
      volumeLabel: 'Vol/mes',
      empty: 'No hay keywords en esta categoría.',
      unclustered: 'Sin agrupar',
    },
    brand: {
      client: {
        title: 'Tu marca',
        subtitle: 'Keywords que mencionan tu marca.',
      },
      competitor: {
        title: 'Marcas de competidores',
        subtitle: 'Keywords que mencionan a tus competidores.',
      },
    },
    skip: {
      title: 'No atacar',
      subtitle: 'Keywords fuera del scope de tu producto.',
    },
    map: {
      title: 'Mapa competitivo',
      subtitle: 'Volumen vs. dificultad. Cada punto es una keyword.',
      xAxis: 'Dificultad (KD)',
      yAxis: 'Volumen mensual',
      empty: 'No hay datos suficientes para el mapa.',
    },
    selection: {
      count_one: '{{count}} keyword seleccionada',
      count_other: '{{count}} keywords seleccionadas',
      createContentPlan: 'Planear contenidos',
      clear: 'Limpiar selección',
    },
  },
  form: {
    client: {
      label: 'Tu dominio',
      placeholder: 'Elegí un dominio',
      empty: 'No tenés sitios cargados. Agregá uno en Configuración.',
    },
    market: {
      label: 'Mercado',
      placeholder: 'Elegí un mercado',
      noLabsHint: 'Sin datos para Keyword Gap',
      countries: {
        CO: 'Colombia',
        AR: 'Argentina',
        MX: 'México',
        ES: 'España',
        CL: 'Chile',
        PE: 'Perú',
        BR: 'Brasil',
        GT: 'Guatemala',
        US: 'Estados Unidos',
        GB: 'Reino Unido',
        DE: 'Alemania',
        FR: 'Francia',
      },
    },
    competitors: {
      label: 'Competidores a analizar',
      empty: 'No tenés competidores cargados. Agregá al menos uno con el campo de abajo.',
      adHocLabel: 'Sumar competidor por dominio',
      adHocPlaceholder: 'ej. competidor.com',
      addAdHoc: 'Agregar competidor',
      removeAdHoc: 'Quitar competidor',
    },
    advanced: {
      strategy: {
        label: 'Estrategia de selección',
        options: {
          by_volume: {
            label: 'Por volumen',
            description: 'Las keywords con más búsquedas mensuales.',
          },
          by_traffic_potential: {
            label: 'Por potencial de tráfico',
            description: 'Las que mejor tráfico estimado generan a tus competidores.',
          },
          striking_distance: {
            label: 'Striking distance',
            description: 'Donde ya rankeás en posiciones 11-30: oportunidades cercanas al top 10.',
          },
        },
      },
      volumePreset: {
        label: 'Enfoque del análisis',
        options: {
          discovery: {
            label: 'Descubrimiento',
            description: 'Equilibrado: oportunidades con volumen interesante pero sin ruido excesivo.',
          },
          long_tail: {
            label: 'Long-tail',
            description: 'Volumen bajo, alta precisión: nichos específicos para temas muy enfocados.',
          },
          high_volume: {
            label: 'Alto volumen',
            description: 'Búsquedas masivas: más alcance pero también más ruido y dificultad.',
          },
          custom: {
            label: 'Personalizado',
            description: 'Definí vos los límites mínimo y máximo.',
          },
        },
      },
      volumeMin: 'Volumen mínimo',
      volumeMax: 'Volumen máximo',
      volumeMinShort: 'Mín.',
      volumeMaxShort: 'Máx.',
      cap: {
        label: 'Tope de keywords',
        hint: 'Cuántas keywords analizar como máximo. Más keywords = análisis más exhaustivo pero más lento.',
      },
    },
    submit: 'Lanzar análisis',
    submitting: 'Lanzando…',
    submitError: 'No se pudo lanzar el análisis. Revisá los datos e intentá de nuevo.',
    errors: {
      clientDomainRequired: 'El dominio es obligatorio.',
      marketRequired: 'Elegí un mercado.',
      competitorsMin: 'Elegí al menos un competidor.',
      competitorsMax: 'Máximo 4 competidores por análisis.',
      adHocDomainRequired: 'El dominio no puede estar vacío.',
      volumeRange: 'El volumen mínimo no puede ser mayor al máximo.',
    },
  },
  coverage: {
    title: 'Cobertura de datos',
    subtitle: 'Cuanto más completo, mejores los resultados.',
    score: '{{done}}/{{total}}',
    checks: {
      website: {
        label: 'Tu sitio',
        doneHint: 'Tenés al menos un sitio configurado.',
        pendingHint: 'Agregá tu sitio principal.',
      },
      competitors: {
        label: 'Competidores',
        doneHint: 'Hay competidores cargados.',
        pendingHint: 'Cargá al menos un competidor para enriquecer el análisis.',
      },
      orgContext: {
        label: 'Contexto del negocio',
        doneHint: 'Tenés todos los detalles de tu empresa cargados.',
        pendingHint: 'Completá todos los detalles de tu empresa.',
      },
      knowledgeBase: {
        label: 'Base de conocimiento',
        doneHint: 'Tu sitio está indexado en la base de conocimiento.',
        pendingHint: 'Indexá tu sitio en la base de conocimiento para sugerencias más precisas.',
      },
    },
  },
  categories: {
    shared: 'Compartidas',
    missing: 'Faltantes',
    weak: 'Débiles',
    strong: 'Fuertes',
    untapped: 'Sin atender',
    unique: 'Únicas',
    all: 'Todas',
  },
  intent: {
    informational: {
      name: 'Informacional',
      description: 'El usuario busca una respuesta a una pregunta específica o un tema en general.',
    },
    navigational: {
      name: 'Navegacional',
      description: 'El usuario busca llegar a una página o sitio web específico.',
    },
    commercial: {
      name: 'Comercial',
      description: 'El usuario está investigando productos, servicios o marcas antes de comprar.',
    },
    transactional: {
      name: 'Transaccional',
      description: 'El usuario está listo para completar una compra o realizar una acción.',
    },
    unknown: {
      name: 'Sin clasificar',
      description: 'No tenemos información de intención de búsqueda para esta keyword.',
    },
  },
  competitiveMap: {
    title: 'Mapa competitivo',
    youMarker: 'vos',
    axisX: 'Universo',
    axisY: 'Overlap',
    quadrant: {
      nicheRival: 'Pisan tu nicho',
      directRival: 'Rivales directos',
      peripheral: 'Periféricos',
      parallel: 'Mercados paralelos',
    },
    tooltip: {
      universe: 'Universo',
      overlap: 'Overlap',
      missing: 'Faltantes',
    },
  },
  table: {
    select: 'Seleccionar',
    selectAll: 'Seleccionar todo',
    keyword: 'Palabra clave',
    intent: 'Intención',
    volume: 'Volumen',
    cpc: 'CPC',
    kd: 'Dificultad',
    pageOf: 'Página {{page}} de {{total}}',
    previousPage: 'Página anterior',
    nextPage: 'Página siguiente',
    tooltip: {
      intent: {
        title: 'Intención de búsqueda',
        description:
          'Qué quiere lograr el usuario con la búsqueda. Informacional (aprender), Navegacional (llegar a un sitio), Comercial (comparar antes de comprar) o Transaccional (comprar/accionar).',
      },
      position: {
        title: 'Posición en Google',
        description:
          'Lugar en el que aparece el dominio en los resultados orgánicos. Cuanto más bajo el número, mejor. "—" significa que el dominio no rankea en el top 100.',
      },
      volume: {
        title: 'Volumen de búsqueda',
        description:
          'Cantidad estimada de búsquedas mensuales para esta palabra clave en el mercado elegido.',
      },
      cpc: {
        title: 'Costo por clic (CPC)',
        description:
          'Lo que un anunciante pagaría en promedio por cada clic en un anuncio de Google Ads para esta palabra. Sirve como proxy del valor comercial.',
      },
      kd: {
        title: 'Dificultad de keyword',
        description:
          'Qué tan difícil es rankear en el top 10 para esta palabra clave. Escala 0–100: verde (≤30) es fácil, amarillo (31–60) medio, rojo (>60) difícil.',
      },
    },
  },
  filters: {
    minVolume: 'Vol mín',
    searchKeyword: 'Buscar palabra clave',
    exportCsv: 'Exportar CSV',
  },
} as const
